module.exports = __webpack_public_path__ + "img/C05TechSPQR_ua.f7b1a400.webp";